import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  latestSsePayload,
  getEventResultsSelector,
} from '../../reducers/reigniteSseSlice'
import ReigniteServerSentEvents from '../../components/shared/ReigniteServerSentEvents'
import { ReigniteSsePayload } from '../../utils/types'
import { getLeaderboardResultsPath } from '../../utils/getLeaderboardResultsPath'

export function ReigniteEventSseResults(props: {
  athlinksEventId: number
  divisionId?: number
  eventCourseId?: number
  intervalId?: number
  refetch: () => void
  correlationId?: string
  setCorrelationId?: (correlationId: string) => void
}) {
  const {
    athlinksEventId,
    divisionId,
    eventCourseId,
    intervalId,
    refetch,
    correlationId,
    setCorrelationId,
  } = props

  const path = getLeaderboardResultsPath({
    athlinksEventId,
    eventCourseId,
    divisionId,
    intervalId
  })

  const sseState = useSelector(getEventResultsSelector(path))

  React.useEffect(() => {
    console.log('sseState', {
      athlinksEventId,
      eventCourseId,
      divisionId,
      intervalId,
      sseState,
    })

    if (correlationId) return
    if (sseState?.lastUpdated &&
      sseState.lastPayload?.type === 'results'
    ) {
      if (( // event-wide or race-specific leaderboards
        !eventCourseId || eventCourseId === sseState.lastPayload.payload.raceId
      ) && ( // division-specific leaderboard
          (!divisionId || isNaN(divisionId)) || (divisionId === sseState.lastPayload.payload.divisionId)
        ) && ( // interval-specific results page (rbi)
          (!intervalId || isNaN(intervalId)) || (intervalId === sseState.lastPayload.payload.intervalId)
        )) {
        try {
          refetch()
        }
        catch (err) {
          console.warn(err)
        }
      }
    }
  }, [
    athlinksEventId,
    eventCourseId,
    divisionId,
    intervalId,
    refetch,
    sseState,
    correlationId,
  ])
  const dispatch = useDispatch()

  const onMessage = React.useCallback(
    (data: ReigniteSsePayload) => {
      dispatch(
        latestSsePayload({
          path,
          ...data
        })
      )
      if (data.payload?.correlationId) {
        setCorrelationId?.(data.payload?.correlationId)
      }
    },
    [
      path,
      dispatch,
      setCorrelationId,
    ]
  )
  return (
    <>
      {path && <ReigniteServerSentEvents
        onMessage={onMessage}
        path={path}
      />}
    </>
  )
}
